// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"41328462","787":"0c6b0da6"}[chunkId] + ".chunk.js";
};